export type IActive = 'delta' | 'river' | 'solar' | 'smart' | 'others';

type IProductOffItem = {
    name: string;
    value: string;
};

const imgUrlConfig: Record<IActive, Record<string, string>> = {
    delta: {
        us: 'https://websiteoss.ecoflow.com/upload/image/1723449353880/DELTA%20Series.png',
    },
    river: {
        us: 'https://websiteoss.ecoflow.com/upload/image/1723449374816/RIVER%20Series.png',
    },
    solar: {
        us: 'https://websiteoss.ecoflow.com/upload/image/1723449388284/Solar%20Panels.png',
    },
    smart: {
        us: 'https://websiteoss.ecoflow.com/upload/image/1723449403591/Smart%20Devices.png',
    },
    others: {
        us: 'https://websiteoss.ecoflow.com/upload/image/1723449440734/Others.png',
    },
};

const messageConfig: Record<IActive, Record<string, string>> = {
    delta: {
        us: '',
    },
    river: {
        us: '',
    },
    solar: {
        us: '',
    },
    smart: {
        us: '',
    },
    others: {
        us: '* Similar products from other brands will be included. You do not need to return non-EcoFlow branded products.',
    },
};

const offListConfig: Record<IActive, Record<string, IProductOffItem[]>> = {
    delta: {
        us: [
            {
                name: 'DELTA Pro',
                value: '$1,000',
            },
            {
                name: 'DELTA Pro Extra Battery',
                value: '$800',
            },
            {
                name: 'DELTA 2 Max',
                value: '$650',
            },
            {
                name: 'DELTA 2 Max Extra Battery',
                value: '$350',
            },
            {
                name: 'DELTA 2',
                value: '$300',
            },
            {
                name: 'DELTA Max',
                value: '$600',
            },
            {
                name: 'DELTA Max Extra Battery',
                value: '$300',
            },
            {
                name: 'DELTA',
                value: '$250',
            },
            {
                name: 'DELTA mini',
                value: '$40',
            },
        ],
        ca: [
            {
                name: 'DELTA Pro 3',
                value: '$1,200',
            },
            {
                name: 'DELTA Pro 3 Extra Battery',
                value: '$1,000',
            },
            {
                name: 'DELTA Pro',
                value: '$1,000',
            },
            {
                name: 'DELTA Pro Extra Battery',
                value: '$800',
            },
            {
                name: 'DELTA 2 Max',
                value: '$650',
            },
            {
                name: 'DELTA 2 Max Extra Battery',
                value: '$350',
            },
            {
                name: 'DELTA 2',
                value: '$300',
            },
            {
                name: 'DELTA Max Extra Battery',
                value: '$300',
            },
        ],
    },
    river: {
        us: [
            {
                name: 'RIVER 2 Pro',
                value: '$100',
            },
            {
                name: 'RIVER 2 Max',
                value: '$80',
            },
            {
                name: 'RIVER 2',
                value: '$50',
            },
            {
                name: 'RIVER',
                value: '$100',
            },
            {
                name: 'RIVER Max/Max Plus',
                value: '$20',
            },
            {
                name: 'RIVER mini/mini Wireless',
                value: '$10',
            },
            {
                name: 'RIVER Plus',
                value: '$10',
            },
        ],
        ca: [
            {
                name: 'RIVER 2 Pro',
                value: '$100',
            },
            {
                name: 'RIVER 2 Max',
                value: '$80',
            },
            {
                name: 'RIVER 2',
                value: '$50',
            },
            {
                name: 'RIVER',
                value: '$100',
            },
            {
                name: 'RIVER Max/Max Plus',
                value: '$20',
            },
            {
                name: 'RIVER mini/mini Wireless',
                value: '$10',
            },
            {
                name: 'RIVER Plus',
                value: '$10',
            },
        ],
    },
    solar: {
        us: [
            {
                name: '400W Solar Panel',
                value: '$200',
            },
            {
                name: '220W Solar Panel',
                value: '$100',
            },
            {
                name: '160W Solar Panel',
                value: '$80',
            },
            {
                name: '110W Solar Panel',
                value: '$60',
            },
        ],
        ca: [
            {
                name: '400W Solar Panel',
                value: '$200',
            },
            {
                name: '220W Solar Panel',
                value: '$100',
            },
            {
                name: '160W Solar Panel',
                value: '$80',
            },
            {
                name: '110W Solar Panel',
                value: '$60',
            },
        ],
    },
    smart: {
        us: [
            {
                name: 'WAVE 2',
                value: '$100',
            },
            {
                name: 'GLACIER',
                value: '$90',
            },
            {
                name: 'WAVE 1',
                value: '$30',
            },
        ],
        ca: [
            {
                name: 'WAVE 2',
                value: '$100',
            },
            {
                name: 'GLACIER',
                value: '$90',
            },
        ],
    },
    others: {
        us: [
            {
                name: 'Jackery 1000 V2',
                value: '$50',
            },
            {
                name: 'Jackery 1000 Plus',
                value: '$50',
            },
            {
                name: 'Jackery 1000 Pro',
                value: '$50',
            },
            {
                name: 'Jackery 1000',
                value: '$50',
            },
            {
                name: 'Anker C1000',
                value: '$50',
            },
            {
                name: 'Anker C800',
                value: '$50',
            },
            {
                name: 'Bluetti AC180',
                value: '$50',
            },
            {
                name: 'Jackery Explorer 2000 v2',
                value: '$50',
            },
            {
                name: 'Jackery Explorer 2000 Plus',
                value: '$50',
            },
            {
                name: 'BLUETTI AC200L',
                value: '$50',
            },
            {
                name: 'BLUETTI Elite 200 V2',
                value: '$50',
            },
            {
                name: 'Anker SOLIX F2000',
                value: '$50',
            },
        ],
        ca: [
            {
                name: 'Jackery Explorer 1000 v2',
                value: '$50',
            },
            {
                name: 'Jackery Explorer 1000 Plus',
                value: '$50',
            },
            {
                name: 'Jackery Explorer 1000',
                value: '$50',
            },
            {
                name: 'Jackery 1000 Pro',
                value: '$50',
            },
            {
                name: 'Anker SOLIX C800',
                value: '$50',
            },
            {
                name: 'Anker SOLIX C1000',
                value: '$50',
            },
            {
                name: 'BLUETTI AC180',
                value: '$50',
            },
            {
                name: 'Jackery Explorer 2000 v2',
                value: '$50',
            },
            {
                name: 'Jackery Explorer 2000 Plus',
                value: '$50',
            },
            {
                name: 'BLUETTI AC200L',
                value: '$50',
            },
            {
                name: 'BLUETTI Elite 200 V2',
                value: '$50',
            },
            {
                name: 'Anker SOLIX F2000',
                value: '$50',
            },
        ],
    },
};

export const getDetailList = (
    active: IActive,
    locale: string,
): {
    imgUrl: string;
    productOffList: IProductOffItem[];
    message: string;
} => {
    const imgUrl = imgUrlConfig[active][locale] || imgUrlConfig[active]['us'];
    const productOffList = offListConfig[active][locale] || offListConfig[active]['us'];
    const message = messageConfig[active][locale] || '';

    return {
        imgUrl,
        productOffList,
        message,
    };
};
